import { PopupBuilder } from '@mobile/views/Relation/Shared/Popup/builder/PopupBuilder'

import TimeoutsPopupDetails from './TimeoutsPopupDetails.vue'

export const TimeoutsPopup = new PopupBuilder('Timeout')
  .appendBody(TimeoutsPopupDetails)
  .build()
